exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-new {\n  margin-bottom: 8px;\n}\n", ""]);

// exports
